module.exports = __webpack_public_path__ + "img/our_story_image.a38b976a.png";